var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChapters(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "library_books_black_24dp",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_156",
    "data-name": "Path 156",
    d: "M0,0H16V16H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_157",
    "data-name": "Path 157",
    d: "M3.237,4.473H2v8.656a1.24,1.24,0,0,0,1.237,1.237h8.656V13.129H3.237ZM13.129,2H5.71A1.24,1.24,0,0,0,4.473,3.237v7.419A1.24,1.24,0,0,0,5.71,11.892h7.419a1.24,1.24,0,0,0,1.237-1.237V3.237A1.24,1.24,0,0,0,13.129,2Zm0,8.656H5.71V3.237h7.419ZM6.946,6.328h4.946V7.564H6.946Zm0,1.855H9.419V9.419H6.946Zm0-3.71h4.946V5.71H6.946Z",
    transform: "translate(-0.183 -0.183)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChapters);
export default __webpack_public_path__ + "static/media/chapters.e04b59a6a9d075f09e15d536daa12ad8.svg";
export { ForwardRef as ReactComponent };